import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_CLIENT_ID ?? ''
const tenantId = import.meta.env.VITE_TENANT_ID ?? ''

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: ['User.Read'],
}

export const tokenRequest = {
  scopes: [
    `https://${tenantId}/${clientId}/.default`,
  ],
  forceRefresh: false,
}

export const msalInstance = new PublicClientApplication(msalConfig)
